import {
  calculatePackagePricing,
  calculateVPELines,
  type PackagePricingResult,
  type PricedPackageItem,
} from '@growthdept/blocks/gift-pricing';
import type { GiftPackage } from './types';

/**
 * Enige adapter tussen het rijke app-model en de gedeelde prijsdispatcher.
 * De legacy-fallback beschermt payloads tijdens een database/app expand-contract deploy.
 */
export function calculateGiftPackagePricing(pkg: GiftPackage): PackagePricingResult {
  const items = (pkg.items ?? []) as unknown as PricedPackageItem[];
  const vpeLines = calculateVPELines(items, pkg.quantity);
  return calculatePackagePricing(
    {
      quantity: pkg.quantity,
      handling_cost_per_package: pkg.handling_cost_per_package,
      transport_cost_per_package: pkg.transport_cost_per_package,
      items,
      pricing_model_version: pkg.pricing_model_version ?? 'legacy_v1',
      margin_low_pct: pkg.margin_low_pct ?? pkg.margin_pct ?? 30,
      margin_high_pct: pkg.margin_high_pct ?? pkg.margin_pct ?? 30,
      handling_margin_pct: pkg.handling_margin_pct,
      transport_margin_pct: pkg.transport_margin_pct,
    },
    vpeLines
  );
}
